import React from "react"
import { Box, Typography, Card, CardHeader, CardContent, CardActions } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import Link from "../Link"
import SocialMediaIcons from "../SocialMediaIcons/SocialMediaIcons"
import { PressConstants } from "../../types/press"
import useBrand from "@talentinc/gatsby-theme-ecom/hooks/useBrand"

const siteId2ContactInfo = (siteId: number | undefined, fallbackName: string, fallbackEmail: string) => {
  switch (siteId) {
    case 126:
      return { name: "Beth Watson", email: "press@topcv.co.uk" }
    case 127:
      return { name: "Beth Watson", email: "press@topcv.com" }
    default:
      return { name: fallbackName, email: fallbackEmail }
  }
}

interface InquiryWidgetProps {
  contactName: string
  className?: string
  email: string
  lowerSectionClass?: string
}

const InquiryWidget: React.FC<InquiryWidgetProps> = ({ contactName, email, className, lowerSectionClass }) => {
  const { widgetTitle, socialTitle } = PressConstants
  const { classes, cx } = useStyles()

  // use siteid instead of brandname
  const { site_id } = useBrand()

  const { name: displayName, email: displayEmail } = siteId2ContactInfo(site_id, contactName, email)

  return (
    <Box className={className}>
      <Card className={cx(classes.mediaContact, classes.noRadiusAndShadow)}>
        <CardHeader
          className={cx(classes.paddingZero, classes.widgetTitle)}
          title={
            <Typography className={classes.letterSpacing} variant="h5">
              {widgetTitle}
            </Typography>
          }
        />
        <CardContent className={classes.paddingZero}>
          <Typography variant="body1">{displayName}</Typography>
        </CardContent>
        <CardActions className={classes.paddingZero}>
          <Link href={`mailto:${displayEmail}`}>
            <Typography className={classes.semiBold} variant="body1">
              {displayEmail}
            </Typography>
          </Link>
        </CardActions>
      </Card>
      <Card className={cx(classes.socialConnect, classes.noRadiusAndShadow, lowerSectionClass)}>
        <CardHeader className={classes.paddingZero} title={<Typography variant="body1">{socialTitle}</Typography>} />
        <CardActions className={classes.paddingZero}>
          <SocialMediaIcons containerClass={classes.socialIconsContainer} facebook twitter linkedIn />
        </CardActions>
      </Card>
    </Box>
  )
}

const useStyles = makeStyles()((theme) => ({
  letterSpacing: {
    letterSpacing: "0.1em",
  },
  mediaContact: {
    padding: "2rem",
    backgroundColor: theme.palette.background.default,
  },
  noRadiusAndShadow: {
    borderRadius: 0,
    boxShadow: "none",
  },
  paddingZero: {
    padding: 0,
  },
  socialConnect: {
    backgroundColor: theme.palette.background.default,
    padding: "2.5rem 2rem",
  },
  semiBold: {
    fontWeight: 600,
  },
  socialIconsContainer: {
    marginTop: "0.75rem",
  },
  widgetTitle: {
    marginBottom: "0.5rem",
  },
}))

export default InquiryWidget
